export default __webpack_public_path__ + "media/menu_ads/blog_menu-d0e92522.png";